module.exports = __webpack_public_path__ + "static/media/7_r_paporotnik_83.13_71.57.a609ab33.png";